import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

import { WithClasses } from '@/styles/types';

const useStyles = makeStyles()((_theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    // These select by position, not by element type: a group can mix a plain
    // button with a wrapped one, and `:first-of-type` would then treat the
    // lone button as both ends of the group. A single child keeps its full
    // styling.
    '& > *:not(:only-child):not(:last-child)': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& > *:not(:first-child)': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: 'none',
    },
  },
}));

export interface ControlButtonGroupProps {
  children: ReactNode;
  classes?: WithClasses<typeof useStyles>;
}

export function ControlButtonGroup({
  children,
  classes: externalClasses,
}: ControlButtonGroupProps) {
  const { classes } = useStyles(undefined, {
    props: { classes: externalClasses },
  });

  return (
    <Stack direction="row" className={classes.root}>
      {children}
    </Stack>
  );
}
